import { render, staticRenderFns } from "./soil.vue?vue&type=template&id=017f67dc&scoped=true&"
import script from "./soil.vue?vue&type=script&lang=js&"
export * from "./soil.vue?vue&type=script&lang=js&"
import style0 from "./soil.vue?vue&type=style&index=0&id=017f67dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017f67dc",
  null
  
)

export default component.exports